import { mapState } from 'pinia'
import { useTrackStore } from '@/stores/track'

const languageLogic = {
  computed: {
    ...mapState(useTrackStore, { trackCurrent: 'current' }),
  },
  methods: {
    localizedTokens(baseToken) {
      let track = this.trackCurrent ? this.trackCurrent.path : 'default'
      let audience = this.trackCurrent ? this.trackCurrent.target_audience : 'chw'
      audience = audience === 'doctor' ? 'chw' : audience
      track = track === 'all' ? 'default' : track

      return [
        `${baseToken}.${audience}.${track}`,
        `${baseToken}.default.${track}`,
        `${baseToken}.${audience}`,
        baseToken
      ]
    },
    localizedToken(baseToken, locale) {
      let tokenCheck = this.localizedTokens(baseToken)
      let localizedToken
      tokenCheck.every(token => {
        localizedToken = token
        return (this.$i18n.t(token, locale) === token)
      })

      if (localizedToken === baseToken && locale) {
        tokenCheck.every(token => {
          localizedToken = token
          return (this.$i18n.t(token) === token)
        })
      }
      return localizedToken
    },
  }
}

export default languageLogic
